export default __webpack_public_path__ + "static/about-fa776485c0d5370f3d8a2c6bd31d19b9.mp4";